

























































































































import { GPageBase } from '@/mixins';
import draggable from 'vuedraggable';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { GrowingPurpose } from '@/models/student/growing-purpose';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import { SchoolGroupDetail } from '@/models/school-group/school-group-detail';
import { SchoolGroupStudent } from '@/models/school-group/school-group-student';
import { GEnum } from '@/constants/enum.defination';
import { masterModule } from '@/store/modules/entities/master.module';
import { groupModule } from '@/store/modules/entities/group.module';
import { SchoolGroupUpdateRequest } from '@/models/school-group/school-group-update-request';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import GTopicSubject from '@/components/GTopicSubject.vue';
import GGroupEditItemCell from '@/views/GGroupEdit/GGroupEditItemCell.vue';
import GGroupEditValueCell from '@/views/GGroupEdit/GGroupEditValueCell.vue';
import { Student } from '@/models/student/student';
import GGroupDraggable from '@/components/GGroupDraggable.vue';
import { globalModule } from '@/store/modules/global.module';

@Component({
  name: 'GGroupEdit',
  components: {
    GGroupDraggable,
    GGroupEditValueCell,
    GGroupEditItemCell,
    GTopicSubject,
    GTitleBar,
    GCustomBreadCrumb,
    draggable,
  },
  computed: {},
  methods: {},
  validations: {},
})
export default class GGroupProposal extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  options: any = { group: 'drag_list' };
  schoolGroup: SchoolGroupStudent[] = [];

  async mounted() {
    this.breadCrumbItems = [
      { title: this.$t('HOME').toString(), icon: 'ios-home', routerPath: '/pages/home' }, { title: this.$t('SCHOOL_CLASS_MANAGEMENT').toString(), routerPath: '/pages/class-management' }, { title: this.$t('EDIT_GROUP').toString() }];
    await masterModule.fetchGrowingPurposes();
    await groupModule.fetchSchoolGroupDetail(parseInt(this.$route.params.id));
    this.setSchoolGroups();
  }

  get isOldSchoolYear(): boolean {
    return globalModule.isOldSchoolYear;
  }

  get growingPurposes(): GrowingPurpose[] {
    return masterModule.growingPurposes;
  }

  get purposeOfTraining(): string {
    if (this.growingPurposes && this.schoolGroupDetail) {
      const growingPurpose = this.growingPurposes.find((growingPurpose: GrowingPurpose) => growingPurpose.growingPurposeID === this.schoolGroupDetail.growingPurpose);
      if (growingPurpose) {
        return growingPurpose.title;
      }
    }
  }

  get schoolGroupDetail(): SchoolGroupDetail {
    return groupModule.schoolGroupDetail;
  }

  get registeredStudents(): number {
    if (this.schoolGroupDetail.group) {
      return this.schoolGroupDetail.group.map((singleGroup: SchoolGroupStudent) => singleGroup.studentList.length).reduce((a: number, b: number) => a + b, 0);
    }
  }

  get hasChildGroupFourMembers(): boolean {
    let hasMembers: boolean = true;
    if (this.schoolGroup.length > 0) {
      hasMembers = this.schoolGroup.every((group: SchoolGroupStudent) => {
        return group.studentList.length >= 3;
      });
    }
    return hasMembers;
  }

  get preventSubmitGroupingPropsal(): boolean {
    return !this.hasChildGroupFourMembers;
  }

  setSchoolGroups() {
    if (this.schoolGroupDetail) {
      this.schoolGroup = this.schoolGroupDetail.group;
    }
  }

  handleGroupEditSubmit() {
    let schoolGroupRequestData: SchoolGroupUpdateRequest = {
      groupID: parseInt(this.$route.params.id),
      data: {
        group: [],
        name: this.schoolGroupDetail.name,
      },
    };

    if (this.schoolGroup.length > 0) {
      this.schoolGroup.forEach((group: SchoolGroupStudent) => {
        let singleGroup: any = {
          groupID: group.groupID,
          studentIDs: group.studentList.map((student: Student) => student.studentID),
        };
        schoolGroupRequestData.data.group.push(singleGroup);
      });
    }

    groupModule.updateSchoolGroup(schoolGroupRequestData).then((response: any) => {
      this.showNotice(GEnum.MessageType.Success, this.$t('SUCCESS').toString(), this.$t('MESSAGE_UPDATED').toString(), 5);
      this.$router.push('/pages/class-management');
    });
  }

  handleGroupEditBack() {
    history.back();
  }

  handleFileDownloadButtonClick() {
    groupModule.downloadProgress(parseInt(this.$route.params.id));
  }
}
